import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ExtraService } from '../../core/services/extra.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as firebase from 'firebase/app';
import { NewPageService } from '../../templates/new-page/service/new-page.service';
import { Constants } from '../../core/config/Constants';
import { MultiUtility } from '../../shared/multi-utility';
import { MultiUtilityService } from '../../core/services/multi-utility.service';
import { Category } from '../../core/models/category';
import { Speaker } from '../../core/models/speaker';
import { SpeakerService } from '../../core/services/speaker.service';

@Component({
	selector: 'app-speaker-add',
	templateUrl: './speaker-add.component.html',
	styleUrls: ['./speaker-add.component.css'],
	providers: [SpeakerService, ExtraService, NewPageService]
})
export class SpeakerAddComponent extends MultiUtility implements OnInit {
	@ViewChild('dropDown', { read: ViewContainerRef }) dropDown: ViewContainerRef;

	buttonMessage = Constants.SUBMIT_BUTTON_MESSAGE;
	eventId: string;

	pageTitle: string = 'Create Speakers';
	editTitle: string = 'Edit Speakers';

	dropzoneActive: boolean = false;

	speakerId: string;
	speakerCount = 0;
	speaker = new Speaker();
	speakerTypeText: string;

	categoryOrderList: Array<any> = [];

	bannerImageFile: File = null;

	constructor(private router: Router,
		newPageService: NewPageService,
		_cfr: ComponentFactoryResolver,
		private speakerService: SpeakerService,
		extraService: ExtraService,
		multiUtilityService: MultiUtilityService,
		private route: ActivatedRoute) {

		super(multiUtilityService, extraService, newPageService, _cfr);
	}

	ngOnInit() {
		super.initComponentThings();
		this.initSpeakerInfo();
	}

	private initThings() {
		this.aboutListUp(this.speaker, this.dropDown);
		this.aboutListDown(this.speaker, this.dropDown);
		this.aboutListRemove(this.speaker);
	}

	private initSpeakerInfo() {
		this.route.queryParams.subscribe(params => {
			this.eventId = params['eventId'];
			this.getSpeakerCategory(params['eventId']);

			if (params['eventId']) {
				if (params['speakerId']) {
					this.speakerId = params['speakerId'];
					this.getSpeakerById(params['eventId'], params['speakerId']);
				} else {
					this.getSpeakerCount(params['eventId']);
				}
			}
			this.extraService.setCurrentEventId(params['eventId']);
		});
	}

	getSpeakerCategory(id) {
		this.categoryOrderList = [];
		this.speakerService.getSpeakerType(id).subscribe(event => {
			if (event) {
				for (let key in event) {
					let speakerOrderType = new Category();
					speakerOrderType.$key = key;
					speakerOrderType.position = event[key].position;
					speakerOrderType.text = event[key].text;
					this.categoryOrderList[event[key].position] = speakerOrderType;
				}
			}
		});
	}

	getSpeakerById(eventId: string, speakerId: string) {
		this.speakerService.getSpeakerById(eventId, speakerId).subscribe(event => {
			if (event) {
				this.speaker = event;
				console.log("huuh  " + this.speaker);

				this.speaker = new Speaker();
				this.speaker.name = event.name;
				this.speaker.prefix = event.prefix === undefined ? null : event.prefix;
				this.speaker.position = event.position;
				this.speaker.email = event.email === undefined ? null : event.email;
				this.speaker.type = event.type === undefined ? null : event.type;
				this.speaker.fileCMId = event.fileCMId === undefined ? null : event.fileCMId;
				this.speaker.profileImageUri = event.profileImageUri === undefined ? null : event.profileImageUri;
				this.speaker.isEmailVisible = event.isEmailVisible === undefined ? null : event.isEmailVisible;
				this.speaker.isPhoneNumberVisible = event.isPhoneNumberVisible === undefined ? null : event.isPhoneNumberVisible;
				this.speaker.isProfileImageVisible = event.isProfileImageVisible === undefined ? null : event.isProfileImageVisible;
				this.speaker.phoneNo = event.phoneNo === undefined ? null : event.phoneNo;
				this.speaker.organization = event.organization === undefined ? null : event.organization;
				this.speaker.designation = event.designation === undefined ? null : event.designation;
				this.speaker.facebook = event.facebook === undefined ? null : event.facebook;
				this.speaker.linkedIn = event.linkedIn === undefined ? null : event.linkedIn;
				this.speaker.twitter = event.twitter === undefined ? null : event.twitter;
				this.speaker.instagram = event.instagram === undefined ? null : event.instagram;

				this.speaker.aboutList = event.aboutList === undefined ? [] : event.aboutList;


				if (this.speaker.aboutList) {
					this.speaker.aboutList.forEach(element => {
						this.addComponent(element, this.dropDown, this.eventId);
					});
				} else {
					this.speaker.aboutList = [];
				}
				this.initThings();

				this.getCategoryItemName(eventId, Constants.CATEGORY_SPEAKERS, this.speaker.type).subscribe(event => {
					if (event) {
						console.log('getCategoryItemName	:	' + event);
						this.speakerTypeText = event;
					}
				});
			}
		});
	}

	getSpeakerCount(eventId: string) {
		let x = this.speakerService.getSpeakersList(eventId);
		x.snapshotChanges().subscribe(list => {
			this.speakerCount = list.length;
		});
	}

	checkType(key, text) {
		if (key) {
			this.speaker.type = key;
			this.speakerTypeText = text
		}
	}

	addAboutElement() {
		this.showDropDown(this.dropDown, this.speaker, this.eventId);
	}


	dropHandler(fileList) {
		console.log('File(s) dropped', fileList);
		this.uploadImage(fileList, '');
	}
	dropzoneState($event: boolean) {
		this.dropzoneActive = $event;
	}


	uploadImage(event, source) {
		console.log('Source Logo :: ', source, event, this.speaker);
		this.bannerImageFile = event.files[0];
		console.log(this.bannerImageFile);
		this.uploadImageToStorage(this.bannerImageFile, firebase, this.speaker, this.eventId, Constants.CONTENT_M_TYPE_SPEAKERS, Constants.IMAGE_UPLOAD_TYPE_BANNER);
	}

	submit() {
		this.confirmMessage = null;
		this.isError = false;
		this.errorMessage = [];

		if (this.validate(this.speaker)) {
			if (!this.speakerId) {
				this.disableButton = false;
				this.speaker.position = this.speakerCount;
				let speakerKey = this.speakerService.addSpeakerDetails(this.speaker, this.eventId);
				if (speakerKey) {
					this.confirmMessage = 'Added Successfully';
				}

			} else {
				this.disableButton = false;

				this.speakerService.updateSpeakerDetails(this.speaker, this.eventId, this.speakerId).then(res => {
					console.log("Res,",res);
					console.log("Update Success");
					
					this.confirmMessage = 'Update Successfully';
				}).catch(error => {
					this.disableButton = true;
					this.errorMessage = error.message;
				});
			}
			setTimeout(function () {
				this.confirmMessage = null;
				this.disableButton = true;
				this.router.navigate([Constants.SPEAKER_FORM, this.eventId]);
			}.bind(this), 2000);

		} else {
			this.isError = true;
		}
	}
}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/event/speaker-add/speaker-add.component.ts